import React from "react";
import { googleSignUp } from "../services/googleSignUp";
import { useNavigate } from "react-router-dom";

function SignUp() {
  const navigate = useNavigate();

  function signin() {
    googleSignUp(navigate);
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-surface px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <img
            src="logo.png"
            alt="WaitLessQ"
            className="w-16 h-16 rounded-2xl mx-auto mb-4"
          />
          <h1 className="text-2xl font-bold text-gray-900">WaitLessQ</h1>
          <p className="text-sm text-gray-500 mt-2">
            Manage your restaurant queue effortlessly
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-card p-6 flex flex-col gap-3">
          <button
            onClick={signin}
            className="w-full flex items-center justify-center gap-3 bg-gray-50 hover:bg-gray-100 rounded-xl py-3.5 px-4 border border-gray-200"
          >
            <img src="images/google.jpg" className="w-5 h-5" alt="Google" />
            <span className="text-sm font-semibold text-gray-700">
              Sign in with Google
            </span>
          </button>

          <div className="flex items-center gap-2">
            <div className="flex-1 h-px bg-gray-100" />
            <span className="text-xs text-gray-400">or</span>
            <div className="flex-1 h-px bg-gray-100" />
          </div>

          <button
            onClick={() => navigate("/waiter-login")}
            className="w-full flex items-center justify-center gap-3 bg-primary-bg hover:bg-purple-100 rounded-xl py-3.5 px-4 border border-primary/20"
          >
            <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
            <span className="text-sm font-semibold text-primary">
              Waiter PIN Login
            </span>
          </button>
        </div>

        <p className="text-xs text-gray-400 text-center mt-8">
          By signing in, you agree to our terms of service
        </p>
      </div>
    </div>
  );
}

export default SignUp;
